<template>
  <v-flex xs12 sm6 d-flex>
    <v-text-field
      v-model="nsu"
      label="NSU"
    ></v-text-field>
  </v-flex>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  name: "NsuAcquirer",
  computed: {
    nsu: {
      get() {
        return this.model;
      },
      set(newNsuAcquirer) {
        this.$store.dispatch("payments/setNsuAcquirer", newNsuAcquirer);
        this.model;
      },
    },
    ...mapGetters({
      model: "payments/filtersNsuAcquirer",
    }),
  },
  data: () => ({}),
};
</script>








